import { __assign, __rest } from "tslib";
import React from "react";
import { Button } from "../../button";
import { injectPropsIfTargetNotExisted } from "../util/inject-props-if-target-not-existed";
var fallbackColumnKey = "__removeable_addon__";
var rowDisabled = null;
export function removeable(_a) {
    var _b = _a.onRemove, onRemove = _b === void 0 ? function () { return null; } : _b, _c = _a.width, width = _c === void 0 ? 46 : _c, targetColumnKey = _a.targetColumnKey, _d = _a.icon, icon = _d === void 0 ? "dismiss" : _d, _e = _a.render, render = _e === void 0 ? function (x) { return x; } : _e;
    return {
        getInfo: function () { return ({ name: "removeable" }); },
        onInjectProps: function (props) {
            var columns = props.columns;
            rowDisabled = props.rowDisabled || (function () { return false; });
            columns = injectPropsIfTargetNotExisted(columns, targetColumnKey, {
                key: fallbackColumnKey,
                width: width,
                header: null,
                render: function () { return null; },
            }, true);
            return __assign(__assign({}, props), { columns: columns });
        },
        onInjectColumn: function (previous) { return function (record, rowKey, recordIndex, column, columnIndex) {
            // 不是目标列
            if (column.key !== fallbackColumnKey) {
                return previous(record, rowKey, recordIndex, column, columnIndex);
            }
            var _a = previous(record, rowKey, recordIndex, column, columnIndex), preChildren = _a.children, props = _a.props, result = __rest(_a, ["children", "props"]);
            var children = preChildren;
            // 非表头
            if (recordIndex !== -1 && !rowDisabled(record)) {
                var element = React.createElement(Button, { type: "icon", icon: icon, htmlType: "button" });
                children = (React.createElement("div", { onClick: function (event) { return onRemove(rowKey, { event: event, record: record }); } }, render(element, {
                    children: preChildren,
                    record: record,
                    rowKey: rowKey,
                    recordIndex: recordIndex,
                    disabled: rowDisabled(record),
                })));
            }
            return __assign(__assign({}, result), { props: props, children: children });
        }; },
    };
}
//# sourceMappingURL=removeable.js.map